import { sendEmailVerification } from "firebase/auth";
import { getFunctions, httpsCallable } from "firebase/functions";
import { auth } from "../firebase/config";

export const USE_BRANDED_VERIFICATION_EMAILS =
  process.env.REACT_APP_USE_BRANDED_VERIFICATION_EMAILS === "true";

const getVerificationErrorMessage = (error) => {
  if (error?.code === "functions/resource-exhausted") {
    return error.message || "Please wait before requesting another verification email.";
  }

  if (error?.code === "functions/failed-precondition") {
    return "Verification email is not fully configured yet. Please contact support or try again soon.";
  }

  return "We could not send the verification email right now. Please try again.";
};

const sendBrandedVerificationEmail = async () => {
  const functions = getFunctions(undefined, "us-central1");
  const sendVerification = httpsCallable(functions, "sendBrandedVerificationEmail");
  return sendVerification();
};

const sendFreeFirebaseVerificationEmail = async (user = auth.currentUser) => {
  if (!user) {
    throw new Error("Please log in first.");
  }

  return sendEmailVerification(user);
};

export const sendVerificationEmail = async (user = auth.currentUser) => {
  if (USE_BRANDED_VERIFICATION_EMAILS) {
    try {
      return await sendBrandedVerificationEmail();
    } catch (error) {
      console.warn(
        "Branded verification email failed; falling back to Firebase default verification email.",
        {
          code: error?.code,
          message: error?.message,
        }
      );
    }
  }

  return sendFreeFirebaseVerificationEmail(user);
};

export { getVerificationErrorMessage };
